var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section-page',{attrs:{"title":"Email Integration"}},[_c('app-upgrade-required',{staticClass:"mt-400",attrs:{"is-centered":"","is-large":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }